import { AirportApi } from "@live/api/airport/AirportApi";
import { FlightApi } from "@live/api/flight/FlightApi";
import { ServerApi } from "@live/api/server/ServerApi";
import { createStore } from "vuex";
import { SET_CURRENT_SERVER_BY_ID, SET_CURRENT_FLIGHT_BY_ID, SET_CURRENT_AIRPORT_BY_ICAO, SET_CURRENT_FLIGHT_BY_INDEX, SET_CURRENT_AIRPORT_BY_INDEX, UPDATE_STATE_WITH_IDS, UPDATE_ALL_SERVERS_INFO, UPDATE_CURRENT_SERVER_DETAIL, UPDATE_CURRENT_FLIGHT_DETAIL, UPDATE_CURRENT_AIRPORT_DETAIL } from "./LiveActions";
import { FLICK_TARGET_SWITCH, SET_IS_FLIGHT_FOCUS } from "./LiveMutations";
const privateMutations = {
    SET_IS_SERVER_DETAIL_LOADING: "SET_IS_SERVER_DETAIL_LOADING",
    SET_IS_FLIGHT_AIRPORT_CARD_LOADING: "SET_IS_FLIGHT_AIRPORT_CARD_LOADING",
    SET_ALL_SERVERS_INFO: "SET_ALL_SERVERS_INFO",
    SET_CURRENT_SERVER_SIMPLE: "SET_CURRENT_SERVER_SIMPLE",
    SET_CURRENT_FLIGHT_SIMPLE: "SET_CURRENT_FLIGHT_SIMPLE",
    SET_CURRENT_AIRPORT_SIMPLE: "SET_CURRENT_AIRPORT_SIMPLE",
    SET_CURRENT_SERVER_DETAIL: "SET_CURRENT_SERVER_DETAIL",
    SET_CURRENT_FLIGHT_DETAIL: "SET_CURRENT_FLIGHT_DETAIL",
    SET_CURRENT_AIRPORT_DETAIL: "SET_CURRENT_AIRPORT_DETAIL"
};
export const liveStore = createStore({
    state: function () {
        return {
            isServerDetailLoading: false,
            isFlightAirportCardLoading: false,
            isFlightFocus: true,
            targetSwitch: false,
            allServersInfo: [],
            currentServerSimple: null,
            currentFlightSimple: null,
            currentAirportSimple: null,
            currentServerDetail: null,
            currentFlightDetail: null,
            currentAirportDetail: null
        };
    },
    actions: {
        [UPDATE_STATE_WITH_IDS]: async function ({ dispatch, getters }, payload) {
            await dispatch(UPDATE_ALL_SERVERS_INFO);
            const errorMessages = [];
            let serverId = payload.serverId;
            const allServersInfo = getters.getAllServersInfo;
            const isValidServerId = allServersInfo.findIndex((server) => server.id == serverId) >= 0;
            if (serverId == null) {
                serverId = allServersInfo[0].id;
            }
            else if (!isValidServerId) {
                serverId = allServersInfo[0].id;
                errorMessages.push("ServerId not found");
            }
            await dispatch(SET_CURRENT_SERVER_BY_ID, { id: serverId });
            let flightId = payload.flightId;
            const currentServerDetail = getters.getCurrentServerDetail;
            if (currentServerDetail == null)
                throw "Could not load server info";
            const flights = currentServerDetail.flights;
            const isValidFlightId = flights.findIndex((flight) => flight.id == flightId) >= 0;
            const selectRandomFlightId = () => flights[Math.floor(Math.random() * flights.length)].id;
            if (flightId == null) {
                flightId = selectRandomFlightId();
            }
            else if (!isValidFlightId) {
                flightId = selectRandomFlightId();
                errorMessages.push("FlightId not found");
            }
            await dispatch(SET_CURRENT_FLIGHT_BY_ID, { id: flightId });
            if (errorMessages.length > 0) {
                throw `Overriding - ${errorMessages.join(" & ")}`;
            }
        },
        [UPDATE_ALL_SERVERS_INFO]: async function ({ commit }) {
            const servers = await ServerApi.getAllServersInfo();
            commit(privateMutations.SET_ALL_SERVERS_INFO, servers);
        },
        [UPDATE_CURRENT_SERVER_DETAIL]: async function ({ commit, getters }) {
            commit(privateMutations.SET_IS_SERVER_DETAIL_LOADING, true);
            const serverInfo = getters.getCurrentServerSimple;
            if (serverInfo == null)
                return;
            try {
                const serverDetail = await ServerApi.getServerDetail(serverInfo.id);
                commit(privateMutations.SET_CURRENT_SERVER_DETAIL, serverDetail);
            }
            finally {
                commit(privateMutations.SET_IS_SERVER_DETAIL_LOADING, false);
            }
        },
        [UPDATE_CURRENT_FLIGHT_DETAIL]: async function ({ commit, getters }) {
            commit(privateMutations.SET_IS_FLIGHT_AIRPORT_CARD_LOADING, true);
            const serverSimple = getters.getCurrentServerSimple;
            const flightSimple = getters.getCurrentFlightSimple;
            if (serverSimple == null || flightSimple == null)
                return;
            try {
                const flightDetail = await FlightApi.getFlightDetail(serverSimple.id, flightSimple.id);
                commit(privateMutations.SET_CURRENT_FLIGHT_DETAIL, flightDetail);
            }
            finally {
                commit(privateMutations.SET_IS_FLIGHT_AIRPORT_CARD_LOADING, false);
            }
        },
        [UPDATE_CURRENT_AIRPORT_DETAIL]: async function ({ commit, getters }) {
            commit(privateMutations.SET_IS_FLIGHT_AIRPORT_CARD_LOADING, true);
            const serverSimple = getters.getCurrentServerSimple;
            const airportSimple = getters.getCurrentAirportSimple;
            if (serverSimple == null || airportSimple == null)
                return;
            try {
                const airportDetail = await AirportApi.getAirportDetail(serverSimple.id, airportSimple.icao);
                commit(privateMutations.SET_CURRENT_AIRPORT_DETAIL, airportDetail);
            }
            finally {
                commit(privateMutations.SET_IS_FLIGHT_AIRPORT_CARD_LOADING, false);
            }
        },
        [SET_CURRENT_SERVER_BY_ID]: async function ({ dispatch, commit, getters }, payload) {
            const servers = getters.getAllServersInfo;
            let server = servers.find((server) => server.id == payload.id);
            if (server == undefined) {
                throw "ServerId not found";
            }
            commit(privateMutations.SET_CURRENT_SERVER_SIMPLE, server);
            await dispatch(UPDATE_CURRENT_SERVER_DETAIL);
        },
        [SET_CURRENT_FLIGHT_BY_ID]: async function ({ commit, dispatch, getters }, payload) {
            const serverDetail = getters.getCurrentServerDetail;
            if (serverDetail == null) {
                throw "Null ServerDetail";
            }
            const flight = serverDetail.flights.find((flight) => flight.id == payload.id);
            if (flight == undefined) {
                throw "FlightId not found";
            }
            commit(privateMutations.SET_CURRENT_FLIGHT_SIMPLE, flight);
            await dispatch(UPDATE_CURRENT_FLIGHT_DETAIL);
        },
        [SET_CURRENT_AIRPORT_BY_ICAO]: async function ({ commit, dispatch, getters }, payload) {
            const serverDetail = getters.getCurrentServerDetail;
            if (serverDetail == null) {
                throw "Null ServerDetail";
            }
            const airport = serverDetail.activeAirports.find((airport) => airport.icao == payload.icao);
            if (airport == undefined) {
                throw "Airport ICAO not found";
            }
            commit(privateMutations.SET_CURRENT_AIRPORT_SIMPLE, airport);
            await dispatch(UPDATE_CURRENT_AIRPORT_DETAIL);
        },
        [SET_CURRENT_FLIGHT_BY_INDEX]: async function ({ dispatch, getters }, payload) {
            const server = getters.getCurrentServerDetail;
            if (server == null)
                throw "Null ServerDetail";
            const flightId = server.flights[payload.index].id;
            await dispatch(SET_CURRENT_FLIGHT_BY_ID, { id: flightId });
        },
        [SET_CURRENT_AIRPORT_BY_INDEX]: async function ({ dispatch, getters }, payload) {
            const server = getters.getCurrentServerDetail;
            if (server == null)
                throw "Null ServerDetail";
            const airportIcao = server.activeAirports[payload.index].icao;
            await dispatch(SET_CURRENT_AIRPORT_BY_ICAO, { icao: airportIcao });
        }
    },
    mutations: {
        [FLICK_TARGET_SWITCH]: function (state) {
            state.targetSwitch = !state.targetSwitch;
        },
        [SET_IS_FLIGHT_FOCUS]: function (state, value) {
            state.isFlightFocus = value;
        },
        [privateMutations.SET_IS_SERVER_DETAIL_LOADING]: function (state, value) {
            state.isServerDetailLoading = value;
        },
        [privateMutations.SET_IS_FLIGHT_AIRPORT_CARD_LOADING]: function (state, value) {
            state.isFlightAirportCardLoading = value;
        },
        [privateMutations.SET_ALL_SERVERS_INFO]: function (state, servers) {
            state.allServersInfo = servers;
        },
        [privateMutations.SET_CURRENT_SERVER_SIMPLE]: function (state, server) {
            state.currentServerSimple = server;
        },
        [privateMutations.SET_CURRENT_FLIGHT_SIMPLE]: function (state, flight) {
            state.currentFlightSimple = flight;
        },
        [privateMutations.SET_CURRENT_AIRPORT_SIMPLE]: function (state, airport) {
            state.currentAirportSimple = airport;
        },
        [privateMutations.SET_CURRENT_SERVER_DETAIL]: function (state, server) {
            state.currentServerDetail = server;
        },
        [privateMutations.SET_CURRENT_FLIGHT_DETAIL]: function (state, flight) {
            state.currentFlightDetail = flight;
        },
        [privateMutations.SET_CURRENT_AIRPORT_DETAIL]: function (state, airport) {
            state.currentAirportDetail = airport;
        }
    },
    getters: {
        getIsServerDetailLoading: function (state) {
            return state.isServerDetailLoading;
        },
        getIsFlightAirportCardLoading: function (state) {
            return state.isFlightAirportCardLoading;
        },
        getIsFlightFocus: function (state) {
            return state.isFlightFocus;
        },
        getTargetSwitch: function (state) {
            return state.targetSwitch;
        },
        getAllServersInfo: function (state) {
            return state.allServersInfo;
        },
        getCurrentServerSimple: function (state) {
            return state.currentServerSimple;
        },
        getCurrentFlightSimple: function (state) {
            return state.currentFlightSimple;
        },
        getCurrentAirportSimple: function (state) {
            return state.currentAirportSimple;
        },
        getCurrentServerDetail: function (state) {
            return state.currentServerDetail;
        },
        getCurrentFlightDetail: function (state) {
            return state.currentFlightDetail;
        },
        getCurrentAirportDetail: function (state) {
            return state.currentAirportDetail;
        }
    }
});
